import {
    SET_REVENUE_CAT_LOGS,
    SET_REVENUE_CAT_LOGS_LOADING,
    SET_REVENUE_CAT_LOGS_ERROR,
    SET_REVENUE_CAT_LOGS_PAGINATION,
    SET_REVENUE_CAT_LOGS_FILTERS,
    RESET_REVENUE_CAT_LOGS,
} from "../constants";

const initialState = {
    logs: [],
    loading: false,
    error: null,
    pagination: {
        totalCount: 0,
        limit: 25,
        offset: 0,
        hasMore: false,
    },
    filters: {
        eventType: "",
    },
};

const revenueCatLogsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_REVENUE_CAT_LOGS:
            return {
                ...state,
                logs: action.payload,
                error: null,
            };

        case SET_REVENUE_CAT_LOGS_LOADING:
            return {
                ...state,
                loading: action.payload,
            };

        case SET_REVENUE_CAT_LOGS_ERROR:
            return {
                ...state,
                error: action.payload,
            };

        case SET_REVENUE_CAT_LOGS_PAGINATION:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    ...action.payload,
                },
            };

        case SET_REVENUE_CAT_LOGS_FILTERS:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload,
                },
            };

        case RESET_REVENUE_CAT_LOGS:
            return initialState;

        default:
            return state;
    }
};

export default revenueCatLogsReducer;
